import { ProductionModuleState } from "../store/ProductionModuleState";
import * as actions from "./actions";

/**
 * The Transportation Module Redux Reducer
 * @param state The IApplicationState for this reducer
 * @param action Standard Redux action payload of a type and payload 
 */
export function productionReducer(state = new ProductionModuleState(), action: IReduxAction) {
    switch (action.type) {                  
        /**
         * Planning
         */
        case actions.PRODUCTION_PLANNING_CURRENT_TAB:
            return Object.assign({}, state, {
                selectedPlanningTab: action.payload
            });   
        case actions.PRODUCTION_LINE_MANAGEMENT_SELECT_LINE:
            return Object.assign({}, state, {
                selectedLine: action.payload
            });          
        default:
            return state;
    }
}
